import { UploadServiceGenerator } from "@hungphongbk/vth-sdk";

export const upload = UploadServiceGenerator({
  uploadHost: process.env.REACT_APP_UPLOAD_API_URL as string,
  token: process.env.REACT_APP_UPLOAD_API_TOKEN as string,
});
